module.exports = __webpack_public_path__ + "391630bd50ff49ed345e7b9b40c7d052.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/picture/Stanley.jpg
// module id = 550
// module chunks = 0